<template>
  <div>
    <h3 class="modal-title"> ATTENDANCE CONFIG </h3>
    <b-form-group :class="{'error-input' : $v.data_attendance.title.$error}">
      <label> Attendance Config Title </label>
      <j-input
        v-model="$v.data_attendance.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeAttendance">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveAttendance">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_attendance: {
      title: {
        required,
      },
      // attendance: {
      //   required,
      // },
    },
  },
  data() {
    return {
      data_attendance: {
        title: '',
        // attendance: null,
      },
    };
  },
  computed: {
    generateDataAttendance() {
      const data = {
        // value_id: `${this.data_attendance.attendance.id}`,
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_attendance.title,
        component_master_id: this.dataMaster.id,
        info: '',
      };
      return data;
    },

    generateDataAttendanceUpdate() {
      const data = {
        // value_id: `${this.data_attendance.attendance.id}`,
        value_id: '0',
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_attendance.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: '',
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      // this.data_attendance.attendance = {
      //   id: JSON.parse(this.dataEdit.info).id,
      //   name: JSON.parse(this.dataEdit.info).name,
      // };
      this.data_attendance.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),

    saveAttendance() {
      this.$v.data_attendance.$touch();
      if (!this.$v.data_attendance.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataAttendance,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataAttendanceUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeAttendance();
      }
    },

    closeAttendance() {
      this.$emit('close-field');
      this.data_attendance.title = '';
      // this.data_attendance.attendance = null;
      setTimeout(() => {
        this.$v.data_attendance.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/times/jAttendanceConfigSetup.vue